import { render, staticRenderFns } from "./expressInfo.vue?vue&type=template&id=e1262c1e&scoped=true&"
import script from "./expressInfo.vue?vue&type=script&lang=js&"
export * from "./expressInfo.vue?vue&type=script&lang=js&"
import style0 from "./expressInfo.vue?vue&type=style&index=0&id=e1262c1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1262c1e",
  null
  
)

export default component.exports